export const attributesToCompare = [
    "cameraModel",
    "spectralRange",
    "pitch",
    "detectorType",
    "detectorFormat",
    "readingMode",
    "detectorCooling",
    "temperatureMeasuringRange",
    "measuringAccuracy",
    "temperatureResolution",
    "irFrameRateFfHfQfPf",
    "windowMode",
    "focus",
    "focusTime",
    "lensFocalLength",
    "zoomAdjustmentTime",
    "imageFormatOptomechanicalMicroscan",
    "imageRecordingPrinciple",
    "apertur",
    "storageMedia",
    "imageStorage",
    "realtimeStorage",
    "eversharpFunction",
    "fieldOfViewIrPixels",
    "closeUpFocus",
    "maximumDetectionRange",
    "zoom",
    "digitalColourVideoCamera",
    "detectionRangeOfOnePerson",
    "detectionRangeOfAVehicle",
    "dynamicRange",
    "integrationTime",
    "rotatingApertureWheel",
    "rotatingFilterWheel",
    "multiIntegrationTime",
    "pictureSynchronisation",
    "interfaces",
    "trigger",
    "analogSignalsIrigB",
    "tripodMount",
    "powerSupply",
    "integratedMicrophoneAndLoudspeaker",
    "laserRangefinder",
    "integratedGpsSensor",
    "display",
    "colorFinder",
    "handleWithWristStrap",
    "handleWithOperatingFunction",
    "singleHandOperation",
    "shoulderStrap",
    "storageAndOperationTemperature",
    "protectionLevel",
    "shockVibrationResistanceInOperation",
    "dimensionsWeight",
    "automaticFunctions",
    "measurementFunctions",
    "moreFunctions",
    "analysisAndEvaluationSoftware"
];
